import { ShoppingCartCheckout } from '@mui/icons-material'
import { Button, CircularProgress } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  checkout: () => void
  loading?: boolean
  disableSubmission: boolean
}

const BasketFooter: React.FC<Props> = ({ disableSubmission, checkout, loading }) => {
  const { t } = useTranslation()

  return (
    <Button
      startIcon={<ShoppingCartCheckout />}
      color="primary"
      size="small"
      disabled={disableSubmission}
      loadingIndicator={<CircularProgress color="inherit" size={16} />}
      onClick={checkout}
      loading={loading}
      sx={{ px: 2 }}
      variant="contained"
      loadingPosition="start"
    >
      {t('marketplace:checkout')}
    </Button>
  )
}

export default BasketFooter
